import * as Yup from "yup"

/**
 * @typedef {Object} ValidateEmailMessages
 * @property {string} [requiredMessage] Message shown when email is empty.
 * @property {string} [invalidMessage] Message shown when email format is invalid.
 */

/**
 * @typedef {Object} ValidateEmailResult
 * @property {boolean} isValid Indicates whether the email passed validation.
 * @property {string} message Validation error message, or empty string when valid.
 */

/**
 * Validate an email using Yup with optional custom messages.
 * @param {string} email
 * @param {ValidateEmailMessages} [messages]
 * @returns {ValidateEmailResult}
 */
export function ValidateEmail(email, messages = {}) {
  const {
    requiredMessage = "Email is required",
    invalidMessage = "Please enter a valid email address",
  } = messages

  const loginEmailSchema = Yup.string()
    .trim()
    .required(requiredMessage)
    .email(invalidMessage)

  try {
    loginEmailSchema.validateSync(email)
    return { isValid: true, message: "" }
  } catch (error) {
    return {
      isValid: false,
      message: error?.message || invalidMessage,
    }
  }
}